module.exports = __webpack_public_path__ + "static/media/reply.87ba58d9.svg";